import { SCENE_TRANSCRIPTIONS } from 'consts/configCustom';
import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';

window.haveAudioSrc = false;
const TIMEOUT_TRANS_TEXT = 3;

const AmbientAudio = (props) => {
  const { audios } = props;

  const audioRef = useRef();
  const refTimer = useRef();
  const autoPlay = useSelector((state) => state.audio.autoPlay);

  const handlePlay = (e) => {
    const transcription = SCENE_TRANSCRIPTIONS.find((item) =>
      window.location.pathname.includes(item.id)
    );

    if (!transcription) return;
    const elm = document.querySelector('.transcription_container');
    elm.querySelector('.transcription_text').textContent =
      transcription.text_en;
    elm.style.setProperty(
      '--time-scroll',
      `${Math.round(e.target.duration) + TIMEOUT_TRANS_TEXT}s`
    );
    elm.classList.add('playing');
  };

  const handleEnded = (e, item) => {
    refTimer.current = setTimeout(() => {
      document
        .querySelector('.transcription_container')
        ?.classList?.remove('playing');

      if (item.repeat) e?.target?.play();
    }, TIMEOUT_TRANS_TEXT * 1000);
  };

  useEffect(() => {
    const src = audios.map((item) => item.soundUrl);
    window.haveAudioSrc = Boolean(src);

    return () => {
      clearTimeout(refTimer.current);
      document
        .querySelector('.transcription_container')
        ?.classList?.remove('playing');
    };
  }, [audios]);

  return (
    <>
      {audios.map((item, index) => {
        return (
          <audio
            ref={(ref) => (audioRef[index] = ref)}
            className="sceneAudio"
            autoPlay={autoPlay}
            // loop={item.repeat}
            key={index}
            src={item.soundUrl}
            onPlay={handlePlay}
            onEnded={(e) => handleEnded(e, item)}
          ></audio>
        );
      })}
    </>
  );
};

export default AmbientAudio;
